import React from 'react';
import { Link } from 'react-router-dom'; 
import {
    Button,
    Card
} from 'semantic-ui-react';

import Sandbox from './Sandbox.js';

function ReferralCriteria(details) {
    return (
        <Sandbox>
            <Card fluid {...details.properties}>
                <Card.Content>
                    <Card.Header>Referral criteria</Card.Header>
                    <Card.Description>
                        {details.statement}

                        {details.criteria ? details.criteria.map(criterium => (
                            <li>{criterium}</li>
                        )) : ''}
                    </Card.Description>
                </Card.Content>
                <Card.Content extra>
                    <Link to="/"><Button secondary>Next patient</Button></Link>
                </Card.Content>
            </Card>
        </Sandbox>
    );
}

export default ReferralCriteria;
